import mapValues from 'lodash/mapValues'

export enum FeatureFlagName {
  TOGGLE_WHATS_ON_DECK_FILTERS = 'TOGGLE_WHATS_ON_DECK_FILTERS',
  TOGGLE_WHATS_HAPPENING_SEE_MORE = 'TOGGLE_WHATS_HAPPENING_SEE_MORE',
  FEAT_FLAG_GIFT_CARD_LANDING = 'FEAT_FLAG_GIFT_CARD_LANDING',
  FEAT_FLAG_EVENT_NOTY = 'FEAT_FLAG_EVENT_NOTY',
  FEAT_FLAG_CONTENT_BLOCK = 'FEAT_FLAG_CONTENT_BLOCK',
  FEAT_FLAG_MEASUREMENT = 'FEAT_FLAG_MEASUREMENT',
}

export type FeatureFlags = { [key in FeatureFlagName]: boolean }

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = mapValues(
  FeatureFlagName,
  () => false
)
